import type { MenuRecipesState, Recipe } from 'reducers/menu-recipes/recipes'

export const getOfferedRecipes = (state: MenuRecipesState): Recipe[] => {
  const uuidToRecipeMap = state.recipesV3.recipes

  return Object.values(uuidToRecipeMap).filter((recipe: Recipe) => recipe.isOffered)
}
